import script from "./NewsMegafone.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsMegafone.vue?vue&type=script&setup=true&lang=js"

import "./NewsMegafone.vue?vue&type=style&index=0&id=1d81fc52&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d81fc52"]])

export default __exports__